import { RadioGroup } from '@mui/material';
import classNames from 'classnames';
import type { VoidFunctionComponent } from 'react';

import { LabeledRadio } from '../../../generic/Forms';

import css from '../../../generic/Forms/Radio.module.less';

type Props = {
  useGlobalTrackerSettings: boolean;
  isDisabled: boolean;
  onUpdate: (settings: { useGlobalTrackerSettings: boolean }) => void;
};

//  This helps manage the updates, since RadioGroup will treat the value as a string.
enum GlobalTrackerSettingsOptions {
  Global = 'global',
  Project = 'project',
}

/**
 * ProjectIssueTrackerSettingsUseGlobalRadios
 */
const ProjectIssueTrackerSettingsUseGlobalRadios: VoidFunctionComponent<Props> = ({
  useGlobalTrackerSettings,
  isDisabled,
  onUpdate,
}) => {
  return (
    <div className={css['radios-section']}>
      <RadioGroup
        className={classNames(css.radios, css['radios-horizontal'])}
        value={useGlobalTrackerSettings
          ? GlobalTrackerSettingsOptions.Global
          : GlobalTrackerSettingsOptions.Project}
        //  This ensures that we are passing a boolean value back up
        onChange={(_event, val) => onUpdate({ useGlobalTrackerSettings: val === GlobalTrackerSettingsOptions.Global })}
        name="useGlobalTrackerSettings"
      >
        <LabeledRadio
          label="Use existing site settings"
          value={GlobalTrackerSettingsOptions.Global}
          isDisabled={isDisabled}
          isRippleDisabled
        />
        <LabeledRadio
          label="Use custom site settings"
          value={GlobalTrackerSettingsOptions.Project}
          isDisabled={isDisabled}
          isRippleDisabled
        />
      </RadioGroup>
    </div>
  );
};

export default ProjectIssueTrackerSettingsUseGlobalRadios;
